import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Paper, Box, Typography, Grid, type Sx } from '@dhl/theme'
import { WaitingForPayment } from '~/assets/icons_dhl/payment'
import { TickMark } from '~/assets/icons_dhl/tick_mark'

const classes: Record<string, Sx> = {
  root: (theme) => ({
    padding: theme.spacing(4, 4),
    margin: theme.spacing(1),
    flexGrow: 1,
    justifyContent: 'space-around',
  }),
  title: {
    fontWeight: 'bold',
  },
  error: {
    marginTop: '3px',
    fontSize: '14px',
  },
}

export const DelayedPayment: FC = () => {
  const { t } = useTranslation()

  return (
    <Box mt={5}>
      <Paper sx={classes.root}>
        <Grid container direction="row" justifyContent="center">
          <Box>
            <Grid size={12}>
              <Grid container direction="row">
                <Box pr={1}>
                  <TickMark />
                </Box>
                <Typography variant="body2">{t('payment-multibanco-succeeded')}</Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Paper>

      <Paper sx={classes.root}>
        <Grid container direction="row" justifyContent="center">
          <Grid size={9}>
            <Box mt={2}>
              <Typography gutterBottom variant="h6" sx={classes.title} style={{ textTransform: 'uppercase' }}>
                {t('payment-multibanco-explanation-title1')}
              </Typography>
              <Typography gutterBottom variant="body2">
                {t('payment-multibanco-explanation-text1')}
              </Typography>
            </Box>
            <Box mt={2}>
              <Typography gutterBottom variant="h6" sx={classes.title}>
                {t('payment-multibanco-explanation-title2')}
              </Typography>
              <Typography gutterBottom variant="body2">
                {t('payment-multibanco-explanation-text2')}
              </Typography>
            </Box>
          </Grid>
          <Grid container size={3}>
            <Box display={{ xs: 'none', sm: 'none', md: 'block' }}>
              <WaitingForPayment style={{ width: '250px', height: '200px' }} />
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  )
}
